import { filterOptions } from '../model';

export function setValidStatus(status: string | null) {
  const options = Object.values(filterOptions).flatMap((option) => option.items);

  return options.find((option) => option.value === status)?.value;
}
